"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityToJSON = exports.OpportunityFromJSONTyped = exports.OpportunityFromJSON = exports.instanceOfOpportunity = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Opportunity interface.
 */
function instanceOfOpportunity(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "advertiserId" in value;
    isInstance = isInstance && "advertiserName" in value;
    isInstance = isInstance && "advertiserCode" in value;
    return isInstance;
}
exports.instanceOfOpportunity = instanceOfOpportunity;
function OpportunityFromJSON(json) {
    return OpportunityFromJSONTyped(json, false);
}
exports.OpportunityFromJSON = OpportunityFromJSON;
function OpportunityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
        'agencyId': !(0, runtime_1.exists)(json, 'agencyId') ? undefined : json['agencyId'],
        'agencyName': !(0, runtime_1.exists)(json, 'agencyName') ? undefined : json['agencyName'],
        'agencyCode': !(0, runtime_1.exists)(json, 'agencyCode') ? undefined : json['agencyCode'],
        'agencyCommission': !(0, runtime_1.exists)(json, 'agencyCommission') ? undefined : json['agencyCommission'],
        'advertiserId': json['advertiserId'],
        'advertiserName': json['advertiserName'],
        'advertiserCode': json['advertiserCode'],
    };
}
exports.OpportunityFromJSONTyped = OpportunityFromJSONTyped;
function OpportunityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'agencyId': value.agencyId,
        'agencyName': value.agencyName,
        'agencyCode': value.agencyCode,
        'agencyCommission': value.agencyCommission,
        'advertiserId': value.advertiserId,
        'advertiserName': value.advertiserName,
        'advertiserCode': value.advertiserCode,
    };
}
exports.OpportunityToJSON = OpportunityToJSON;
